
export interface IFilterCriteria {
  value: any;
  matchMode: string;
  operator: "and" | "or";
}

export interface IFilter {
  first: number;
  rows: number;
  sortOrder: 1 | -1;
  sortField: string;
  filters: { [key: string]: IFilterCriteria[] };
  globalFilter: null;
}

export class Filter {
  first: number;
  rows: number;
  sortOrder: 1 | -1;
  sortField: string;
  filters: { [key: string]: IFilterCriteria[] };
  globalFilter: null;

  constructor(data: IFilter) {
    this.first = data.first;
    this.rows = data.rows;
    this.sortOrder = data.sortOrder;
    this.sortField = data.sortField;
    this.filters = data.filters;
    this.globalFilter = data.globalFilter;
  }
}
